export default __webpack_public_path__ + "static/media/drug-dental.559e5cf0.PNG";